module.exports = __webpack_public_path__ + "img/limit-d.525b697.svg";